<template>
  <div class="page">
    <h1 class="page__heading">Architektura</h1>
    <div class="page__info">
      <span>
        <a href="/" class="page__info-type">Domů</a> >
        <em>
          <span class="page__info-type">Architektura</span>
        </em>
      </span>
    </div>
    <h3>Omlouvám se, tuto stránku teprve připravuji...</h3>
    <div class="about" v-if="false">
    <img src="img/foto_breta.jpg" alt="Břetislav Krejsa" class="about__image" />
    <div class="about__text">
      <div class="about__text-column">
        <p>
          <b>
            <em>
              Kdybych se narodil o dvacet let dříve, byla by pro mne
              nejpalčivější otázkou dneška svoboda a demokracie. Měl jsem
              však to štěstí, že jsem se narodil jen rok před pádem totality a
              svobodu za mne vybojovali jiní. Za jednu z největších výzev dneška
              proto považuji ochranu životního prostředí.
            </em>
          </b>
        </p>
        <p>
          Architektura, urbanismus a krajinné plánování snad možná nemá na první pohled
          příliš souvislostí s ochranou životního prostředí. Ve skutečnosti však má rozvoj sídel,
          navrhování ekologických staveb nebo jejich propojení s krajinou obrovský vliv na přírodu
          a prostředí, ve které žijeme.
        </p>
        <p>To byl důvod, proč jsem se na konci studia na gymnáziu rozhodl architektuře a územnímu plánování věnovat. Mým cílem je od té doby hledat vždy taková řešení, která budou v souladu s přírodou, ale zároveň budou respektovat požadavky dnešní doby.</p>
        <p>Fakulta architektury na Českém vysokém učení technickém mne přivedla k další oblasti péče o své okolí - k památkové péči.</p>
        <p>Kromě základního vzdělání architekta jsem absolvoval modul Památkové péče, který byl zakončený státní závěrečnou zkouškou. Po studiu jsem pak pokračoval ještě dva roky prací v Národním památkovém ústavu a rozvojem dalšího vzdělávání v této oblasti.</p>
        <p>Díky vztahu k historii jsem získal vhled do postupného utváření a proměny naší krajiny do dnešní podoby. Získané zkušenosti každodenně využívám v procesu územního plánování i při návrhu "nové" architektury, která je v harmonii s architekturou "starou".</p>
        <p>Úcta k historii, přírodě a svobodě ve mne zakořenila díky tomu, že jsem měl od malička možnost vyrůstat ve skautském oddíle. Skauting mne od mých 11 let provází až doposud a kromě výše uvedených hodnot mne naučil samostatnosti a vedení kolektivu lidí.</p>
      </div>
    </div>
  </div>
    <Portfolio :portfolioLinks="portfolioLinks"></Portfolio>
    <Message id="napiste-mi" :messageDesc="'Měli byste zájem o vypracování studie rodinného domu? Potřebujete zpracovat projekt pro stavební povolení? Napište mi!'"></Message>
  </div>
</template>

<script>
import axios from "axios";
import Portfolio from "@/components/Portfolio";
import Message from "@/components/Message";

import moment from "moment";
moment.locale("cs");

export default {
  name: "page",
  components: {
    Message,
    Portfolio
  },
  data() {
    return {
      portfolioLinks: [],
      loading: true,
    };
  },
  created() {
    axios
      .get(
        'items/atelier_projekty?fields=type,date,heading,tags,slug,intro,intro_img.title,intro_img.id&filter={"_or":[{"tags":{"_contains":"architektura"}},{"tags":{"_contains":"stavitelství"}}]}'
      )
      .then((res) => {
        if (res.status == 200) {
          this.portfolioLinks = res.data.data;
          this.loading = false;
        } else {
          //some error handling
        }
      });
  },
  filters: {
    moment: function (date) {
      return moment(date).format("MMMM YYYY");
    },
  },
};
</script>
<style>
.page {
  padding: 0 48px;
}

.page > div {
  padding: 24px 0;
}

.page h1 {
  font-size: 4rem;
  text-align: center;
  letter-spacing: 0;
  margin: 64px 0 0 0;
  text-transform: capitalize;
}

.page h2 {
  font-size: 3rem;
}

.page__info {
  text-align: center;
}

.page__info > span {
  padding: 0 12px;
}

.page__info-type {
  text-transform: capitalize;
}

/* Loader */
.page__loader {
  display: flex;
  justify-page: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  margin: auto;
}

@media only screen and (min-width: 1200px) {
  .page {
    padding-left: 10vw;
    padding-right: 10vw;
  }
}

@media only screen and (max-width: 400px) {
  .page {
    padding: 0 24px;
  }
}
</style>
